// auth.service.ts
import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ENVIRONMENT, API, ChatProviders, STORAGE_KEYS } from 'src/app/_constants/app.constants';
import { LoggerService } from 'src/app/_services/ui/logger/logger.service';
import { SESSION_STORAGE_SERVICE } from 'src/app/_services/session/session.service';
import { StorageService } from 'ngx-webstorage-service';
import { ServiceModule } from 'src/app/_services/service.module';
import { catchError, lastValueFrom, of, take } from 'rxjs';

@Injectable({
  providedIn: ServiceModule
})
export class AuthService {

  asset: any = false;
  token: any = null;
  active: any = true;
  isIAM: boolean = false;
  isCisco: boolean = false;

  constructor(
    @Inject(SESSION_STORAGE_SERVICE) private storage: StorageService,
    private logger: LoggerService,
    private http: HttpClient,
  ) {
  }

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  async auth() {
    this.logger.debug('AuthService: auth()');
    const hostname = this.getHostName();
    const url = `${ENVIRONMENT.PROPERTIES.apiUrl}${API.AUTH}`;

    const body = {
      station: "unknown",
      gate: "unknown"
    }

    if (this.storage.get(STORAGE_KEYS.PARAMS.toString())) {
      let params = this.storage.get(STORAGE_KEYS.PARAMS.toString());

      if (params.a && params.a.length > 0) body.station = params.a;
      if (params.g && params.g.length > 0) body.gate = params.g;
    }
    let params = Object.fromEntries(new URLSearchParams(location.search));

    if (params.a && params.a.length > 0) body.station = params.a;
    if (params.g && params.g.length > 0) body.gate = params.g;

    const response = await new Promise((res: any, rej: any) => {
      this.http.post(encodeURI(url), body, {
        headers: new HttpHeaders({
          'Hostname': hostname,
          'Asset': `${this.asset}`,
        })
      }).pipe(
        catchError(err => {
          return of({ success: false })
        })
      ).subscribe((data: any) => {
        res(data)
      })
    })


    if (response["success"]) {
      this.token = response["data"]["token"];
      this.active = response["data"]["active"];
      this.isCisco = response["data"]["isCisco"];
      if (response["data"]["isIAM"] != undefined) {
        this.isIAM = response["data"]["isIAM"];
      }
      ENVIRONMENT.PROPERTIES.CHAT_PROVIDER = ChatProviders.WEBEX;
      let chatProvider = "Cisco";
      this.logger.debug('AuthService: auth() Chat provider is ', chatProvider);
    } else {
      throw response;
    }
  }

  getHostName() {
    return (location.port == '4200' && location.hostname == 'localhost') ? 'qa.united.fiveout.app' : location.hostname;
  }

  resetToken() {
    this.token = null;
    this.storage.has(STORAGE_KEYS.AUTH) && this.storage.remove(STORAGE_KEYS.AUTH);
  }

  storeToken() {
    this.storage.set(STORAGE_KEYS.AUTH, {
      active: this.active,
      token: this.token,
      isIAM: this.isIAM,
      isCisco: this.isCisco,
    })
  }

  async refreshToken() {
    this.resetToken();
    await this.auth();
    this.storeToken();
  }

}
